var _path, _path2;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgJob = function SvgJob(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.66636 5.50008V4.83341C6.66636 3.35841 6.66636 2.16675 9.33303 2.16675H10.6664C13.333 2.16675 13.333 3.35841 13.333 4.83341V5.50008M6.66636 18.8334H13.333C16.683 18.8334 17.283 17.4917 17.458 15.8584L18.083 9.19175C18.308 7.15841 17.7247 5.50008 14.1664 5.50008H5.83303C2.27469 5.50008 1.69136 7.15841 1.91636 9.19175L2.54136 15.8584C2.71636 17.4917 3.31636 18.8334 6.66636 18.8334Z",
    stroke: "#2E3293",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6669 12.1834V11.3334C11.6669 10.5001 11.6669 10.5001 10.8336 10.5001H9.16693C8.33359 10.5001 8.33359 10.5001 8.33359 11.3334V12.1917M11.6669 12.1834C11.6669 13.0917 11.6586 13.8334 10.0003 13.8334C8.35026 13.8334 8.33359 13.1001 8.33359 12.1917M11.6669 12.1834C13.9704 11.8966 16.1637 11.0308 18.0419 9.66675M8.33359 12.1917C6.17526 11.9501 4.05859 11.1751 2.18359 9.89175",
    stroke: "#2E3293",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgJob, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/job.c8f7b5bb.svg";
export { ForwardRef as ReactComponent };